
import { Injectable, EventEmitter } from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { MagicLinkModel, TabModel } from '@shared/models/platform-tool-models';
import { ActivatedRoute, Router } from '@angular/router';
import { PlatformCommand } from '@shared/commands/command-base';
import {Subject} from "rxjs";
import { CommandService } from '@core/services/command.service';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})

export class PlatformToolDac6FilingSettingsHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;
  activatedRoute?: ActivatedRoute;
  metaData?: any;

  ngUnsubscribe$ = new Subject<void>();
  constructor(private router: Router,
    private commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService) {
      this.invalidateSubject = new InvalidateSubject();
    }
  valueChanged($event: any) {
  }
  setSelectedTab(selectedTab: TabModel): void {

  }
  destroy(): void {

  }

  executeCommand(command: PlatformCommand) {
    console.log(command);
    this.executeCommandToApi(command);

  }
  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();
          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else {
            this.invalidateSubject.invalidate();
          }
        },
        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        });
    }
  }
}
